import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { portalService } from '../services/portalService';

/**
 * Public landing after Stripe Checkout for a clinical invoice.
 * Confirms payment via portal API (no clinician JWT required).
 */
const PortalPaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id') || params.get('sessionId');
  const invoiceId = params.get('invoiceId');
  const [status, setStatus] = useState('confirming');
  const [error, setError] = useState('');
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      setError('Missing Stripe session. If you paid, contact your clinic.');
      return;
    }
    portalService
      .confirmInvoicePayment(sessionId)
      .then((res) => {
        setInvoice(res.data || null);
        setStatus('ok');
      })
      .catch((e) => {
        setStatus('error');
        setError(e.response?.data?.message || e.message || 'Could not confirm payment');
      });
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center space-y-4">
        <h1 className="text-2xl font-semibold text-primary">Payment</h1>
        {status === 'confirming' && (
          <p className="text-gray-600">Confirming your payment…</p>
        )}
        {status === 'ok' && (
          <>
            <p className="text-green-700 font-medium">Thank you — payment received.</p>
            {invoice && (
              <p className="text-sm text-gray-600">
                Invoice {invoice.invoiceNumber} · Status {invoice.status}
              </p>
            )}
            {invoiceId && (
              <p className="text-xs text-gray-400">Ref: {invoiceId}</p>
            )}
          </>
        )}
        {status === 'error' && (
          <p className="text-red-600 text-sm">{error}</p>
        )}
        <Link to="/login" className="text-sm text-primary underline inline-block mt-4">
          Clinic staff sign in
        </Link>
      </div>
    </div>
  );
};

export default PortalPaymentSuccess;
